import { TextField, Tooltip, useTheme } from "@material-ui/core";
import React, { useCallback, useState } from "react";

import { Box } from "../../../../../dtos/box";
import { BoxFeature } from "../types";

import { useSaveNotes } from "./useSaveNotes";

interface Props {
    box: Box;
    onNotesSaved: () => void;
    feature: BoxFeature;
}

export function BoxNotes({
    box,
    onNotesSaved,
    feature,
}: Props) {
    const theme = useTheme();
    const [notes, setNotes] = useState(box.notes);
    const { saveNotes, loading } = useSaveNotes(box.id);

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setNotes(e.currentTarget.value);
    }, []);

    const handleBlur = useCallback(() => {
        if (notes === box.notes) return;
        saveNotes(notes, onNotesSaved);
    }, [notes, box.notes, onNotesSaved, saveNotes]);

    return (<>
        <h2>Box Notes</h2>

        <Tooltip title={feature.reason}>
            <TextField
                value={notes}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={loading || !feature.enabled}
                multiline={true}
                fullWidth={true}
                rows={5}
                variant="filled"
                style={{ backgroundColor: theme.palette.background.paper }}
            />
        </Tooltip>
    </>);
}